// extracted by mini-css-extract-plugin
export var container = "ResearchAndDevelopmentDocuments-module--container--FJ7sK";
export var documentsContainer = "ResearchAndDevelopmentDocuments-module--documentsContainer--8yAv8";
export var document = "ResearchAndDevelopmentDocuments-module--document--FUI4J";